import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Youtube, Instagram, Heart } from 'lucide-react';
import { churchInfo } from '../mockData';

export const Footer = () => {
  return (
    <footer className="bg-[#800020] text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Church Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_faith-fellowship-ga/artifacts/mi0scedb_Logo%202.PNG" 
              alt="Mt. Olive Missionary Baptist Church" 
              className="h-16 w-auto mb-4 bg-white rounded p-1"
            />
            <p className="text-[#fef3c7] text-sm mb-4">
              The Church on the Hill where everybody is somebody.
            </p>
            <div className="flex gap-4">
              <a 
                href={churchInfo.socialMedia.facebook} 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-[#FFD700] transition-colors"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a 
                href={churchInfo.socialMedia.youtube} 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-[#FFD700] transition-colors"
              >
                <Youtube className="h-5 w-5" />
              </a>
              <a 
                href={churchInfo.socialMedia.instagram} 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-[#FFD700] transition-colors"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#FFD700]">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-[#fef3c7] hover:text-[#FFD700] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/ministries" className="text-[#fef3c7] hover:text-[#FFD700] transition-colors">
                  Ministries
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-[#fef3c7] hover:text-[#FFD700] transition-colors">
                  Services & Events
                </Link>
              </li>
              <li>
                <Link to="/media" className="text-[#fef3c7] hover:text-[#FFD700] transition-colors">
                  Sermons
                </Link>
              </li>
              <li>
                <Link to="/give" className="text-[#fef3c7] hover:text-[#FFD700] transition-colors">
                  <a 
                    href="https://www.givelify.com/givenow/1.0/MzQ1NQ==/selection"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Give Online
                  </a>
                </Link>
              </li>
            </ul>
          </div>

          {/* Service Times */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#FFD700]">Service Times</h3>
            <ul className="space-y-3 text-[#fef3c7]">
              <li>
                <div className="font-semibold text-white">Sunday</div>
                <div className="text-sm">1st, 3rd, & 4th Sundays</div>
                <div className="text-sm">Sunday School - 9:30 AM</div>
                <div className="text-sm">Church Service - 10:00 AM</div>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-[#FFD700]">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-[#fef3c7]">
                <MapPin className="h-5 w-5 flex-shrink-0 mt-0.5" />
                <span className="text-sm">{churchInfo.address}</span>
              </li>
              <li className="flex items-center gap-2 text-[#fef3c7]">
                <Phone className="h-5 w-5 flex-shrink-0" />
                <a href={`tel:${churchInfo.phone}`} className="text-sm hover:text-[#FFD700] transition-colors">
                  {churchInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-2 text-[#fef3c7]">
                <Mail className="h-5 w-5 flex-shrink-0" />
                <a href={`mailto:${churchInfo.email}`} className="text-sm hover:text-[#FFD700] transition-colors">
                  {churchInfo.email}
                </a>
              </li>
            </ul>
            <div className="mt-4">
              <h4 className="font-semibold text-white mb-2 text-sm">Office Hours</h4>
              {churchInfo.officeHours.map((schedule, index) => (
                <div key={index} className="text-sm text-[#fef3c7]">
                  {schedule.days}: {schedule.hours}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#8B0000]">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-[#fef3c7]">
            <div className="flex items-center gap-1">
              © {new Date().getFullYear()} {churchInfo.name}. All rights reserved.
            </div>
            <div className="flex items-center gap-1">
              Made with <Heart className="h-4 w-4 text-[#FFD700] fill-current" /> for God's Glory
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
